export function isRaccoonError(error) {
    if (error && typeof error === 'object' && 'messages' in error && Array.isArray(error.messages)) {
        return true;
    }
    return false;
}
